import { Icon } from '@chakra-ui/react';

export const Suitcase = (props) => (
  <Icon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M16.5833 20.2501H7.41667C6.44421 20.2501 5.51158 19.8638 4.82394 19.1761C4.13631 18.4885 3.75 17.5559 3.75 16.5834V9.25008C3.75 8.76385 3.94315 8.29754 4.28697 7.95372C4.63079 7.6099 5.0971 7.41675 5.58333 7.41675H18.4167C18.9029 7.41675 19.3692 7.6099 19.713 7.95372C20.0568 8.29754 20.25 8.76385 20.25 9.25008V16.5834C20.25 17.5559 19.8637 18.4885 19.1761 19.1761C18.4884 19.8638 17.5558 20.2501 16.5833 20.2501Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.3335 7.41667V5.58333C8.3335 5.0971 8.52665 4.63079 8.87047 4.28697C9.21428 3.94315 9.6806 3.75 10.1668 3.75H13.8335C14.3197 3.75 14.786 3.94315 15.1299 4.28697C15.4737 4.63079 15.6668 5.0971 15.6668 5.58333V7.41667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.25 12.4583H17.0417C17.8926 12.4583 18.7086 12.1203 19.3103 11.5186C19.912 10.917 20.25 10.1009 20.25 9.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1667 12.4583H6.95833C6.10743 12.4583 5.29138 12.1203 4.6897 11.5186C4.08802 10.917 3.75 10.1009 3.75 9.25V9.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
